import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { computed } from 'mobx';

interface Props {
	options: AllotmentItem[];
	value: number | null;
	mode: ControlMode;
	onChanged: (value: AllotmentItem | null) => void;
	label?: string;
	placeholder?: string;
	afterLoad?: (selectedOptions: any, options: any[]) => void;
	supplierId?: number;
	productId?: number;
}

export class ProductAllotmentView extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}
	
	render() {
	
		let label = this.props.label;
		if (label === undefined) {
			label = 'Allotment';
		}
		return <div className='filter-panel'>
			<DropdownView
				afterLoad={this.props.afterLoad}
				placeholder={this.props.placeholder}
				label={label}
				disabled={this.props.mode == 'display'}
				model={this.props.value}
				onChanged={(item) => { this.props.onChanged(item != null ? item : null) }}
				options={this.props.options}
				keyField="id"
				textField="name"
				cascadeField={this.props.supplierId ? "supplierId" : null}
				cascadeValue={this.props.supplierId}
			/>

			<div style={{ display: 'inline-flex', alignItems: 'flex-end', marginBottom: '6px' }}>
				{this.props.children}
			</div>
		</div>;
	}
}



// WEBPACK FOOTER //
// ./src/app/products/products/parts/product-allotment.view.tsx